import { Box } from '@chakra-ui/react';
import type { DateTimeUnit } from 'luxon';
import React from 'react';

import MonthPicker from '@components/common/date/MonthPicker';
import QuarterPicker from '@components/common/date/QuarterPicker';
import { DatePickerProps } from '@components/common/date/types';
import YearPicker from '@components/common/date/YearPicker';

interface Props extends DatePickerProps {
  dateType?: DateTimeUnit;
}

function componentForDateType(dateType: DateTimeUnit) {
  switch (dateType) {
    case 'quarter':
      return QuarterPicker;
    case 'year':
      return YearPicker;
    default:
      return MonthPicker;
  }
}

const DatePicker: React.FC<Props> = ({
  minDate,
  maxDate,
  selected,
  onDateSelect,
  focused = true,
  dateType = 'month',
}) => {
  const Picker = componentForDateType(dateType);
  return (
    <Box data-testid="date-picker">
      <Picker
        minDate={minDate}
        maxDate={maxDate}
        selected={selected}
        onDateSelect={onDateSelect}
        focused={focused}
      />
    </Box>
  );
};

export default DatePicker;
